import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import * as XLSX from 'xlsx';
import { FiltrosRepComercial } from 'app/models/FiltrosRepComercial';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosRepCobranzas } from 'app/models/FiltrosRepCobranzas';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-facturas-merito',
  templateUrl: './listado-facturas-merito.component.html',
  styleUrls: ['./listado-facturas-merito.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoFacturasMeritoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['ID', 'NUMERO_FACTURA', 'MONEDA', 'MONTO_NEGOCIADO', 'MONTO_COBRAR', 'FECHA_PAGO'
  , 'DIAS_ATRASO', 'RUC_CLIENTE', 'RAZON_SOCIAL_CLIENTE','RUC_OBLIGADO',
  'RUC_SOCIAL_OBLIGADO','ID_OPERACION','CODIGO_FN_CAVALI'];
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  loadingUser:boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepCobranzas: Subscription = new Subscription();
  DTOFiltrosRepCobranzas: FiltrosRepCobranzas = new FiltrosRepCobranzas();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'comercial';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus) { }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.obtenerListaAccesos();
    this.ListadoRepCobranzas();
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepCobranzas(){
    this.loading = true;
    this.DTOFiltrosRepCobranzas.Tipo = 'facturas_merito';
    this.subRepCobranzas = this.securityService.FiltroListadoRepCobranzas(this.DTOFiltrosRepCobranzas, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepCobranzas.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);
  }
  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.securityService.dataBuffer);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Cobranzas_' + fecha + '.xlsx');
  }
}

